import { FC } from "react";

const DefectTableSettingsForm: FC = () => {
  return <div></div>;
};

export default DefectTableSettingsForm;
